<template>

   <div class="container">

        <div class="claim text-left">
            <strong>{{ $t('about.mainTitle[0]') }} </strong>, <strong>{{ $t('about.mainTitle[1]') }} </strong> {{ $t('about.mainTitle[2]') }}  <strong>{{ $t('about.mainTitle[3]') }} </strong> {{ $t('about.mainTitle[4]') }}  <strong>{{ $t('about.mainTitle[5]') }}</strong> {{ $t('about.mainTitle[6]') }} 
        </div>

       <div class="row heading mt-5">
        <div class="col">
            <div class="highlighted">{{ $t('about.mission.title') }} </div>
            
            <p>{{ $t('about.mission.content') }} </p>

        </div>
        <div class="col-md-6">
            <div class="imgOverlay">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/bD8zutqmst0" title="YouTube video player" frameborder="0" autoplay="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
       </div>


       <div class="row mt-5">
        <div class="col-md-5">
            <div class="imgOverlay">
                <img src="@/assets/img/apropos/reunion2022.jpg" class="img-fluid screenShot" alt="">
            </div>
        </div>
        <div class="col">
            <div class="highlighted">{{ $t('about.story.title') }}</div>
            <p>{{ $t('about.story.content1') }} <a href="https://www.ceresia.fr/" target="blank">{{ $t('about.story.content2') }}</a>. {{ $t('about.story.content3') }} <strong>{{ $t('about.story.content4') }}</strong>. </p>
            <p>{{ $t('about.story.content5') }} <strong>{{ $t('about.story.content6') }}</strong> {{ $t('about.story.content7') }}.</p>
        </div>
       </div>
       



       <div class="highlighted">{{ $t('about.why.title') }}</div>
       <div class="row">
           <div class="col-md-4 values">
            {{ $t('about.why.ref') }}
           </div>
           <div class="col">
            {{ $t('about.why.content1') }}  <div class="claim">{{ $t('about.why.users') }}</div>.
               <div class="row clients-logo text-center">
                    <div class="col-lg-4 logoContainer"><img src="@/assets/img/cooperl.png" alt="Cooperl"></div>
                    <div class="col-lg-4 logoContainer"><img src="@/assets/img/ceresia.png" alt="Ceresia"></div>
                    <div class="col-lg-4 logoContainer"><img src="@/assets/img/vivescia.png" alt="Vivescia"></div>
                    <div class="col-lg-3 logoContainer"><img src="@/assets/img/seveal.png"  alt="Seveal"></div>
                    <div class="col-lg-3 logoContainer"><img src="@/assets/img/logo_novagrain.svg"  alt="Logo Novagrain"></div>
                    <div class="col-lg-4 logoContainer"><img src="@/assets/img/acolyance.png" alt="Acolyance"></div>
                    <div class="col-lg-4 logoContainer"><img src="@/assets/img/prestalyance.png" alt="Prestalyance"></div>
                    <div class="col-lg-4 logoContainer"><img src="@/assets/img/logo-sepac-compagri.jpg" alt="Prestalyance"></div>
                    <div class="col-lg-3 logoContainer"><img src="@/assets/img/logo_capvert.jpg"  alt="Logo Cap Vert"></div>
                    <div class="col-lg-3 logoContainer"><img src="@/assets/img/logo_talian.jpg"  alt="Logo Talian"></div>

                </div>
           </div>
       </div>
       <div class="highlighted">{{ $t('about.values.title') }}</div>
       
       <div class="row">
        
           <div class="col-md-4 values">
            {{ $t('about.values.title1') }}
           </div>
           <div class="col">
            {{ $t('about.values.content1') }}
           </div>
       </div>

       <div class="row">
           <div class="col-md-4 values">
            {{ $t('about.values.title2') }}
           </div>
           <div class="col">
            {{ $t('about.values.content2') }}
           </div>
       </div>

       <div class="row">
           <div class="col-md-4 values">
            {{ $t('about.values.title3') }}
           </div>
           <div class="col">
            {{ $t('about.values.content3') }} <br> <router-link class="btn btn-secondary mt-2" to="/souverainte"> {{ $t('about.values.btn3') }}</router-link>
           </div>
       </div>
       
       <div class="row">
           <div class="col-md-4 values">
            {{ $t('about.values.title4') }}
           </div>
           <div class="col">
            {{ $t('about.values.content41') }} <a href="https://www.climateneutraldatacentre.net/">{{ $t('about.values.content42') }}</a>, {{ $t('about.values.content43') }}.
               <br> <router-link class="btn btn-secondary mt-2" to="/agrivitechpourleclimat"> {{ $t('about.values.btn4') }} </router-link>
           </div>
       </div>
       
       <div class="row">
           <div class="col-md-4 values">
            {{ $t('about.values.title5') }}
           </div>
           <div class="col">
            {{ $t('about.values.content5') }}
           </div>
       </div>



        
       
   </div>
   <MailjetNewsLetter/>
</template>

<script >
import MailjetNewsLetter from '../components/MailjetNewsLetter'

export default {
    name: 'Apropos',
    components:{
        MailjetNewsLetter
    },
    props:{}
}
</script>

<style lang="scss" scoped>

    a{
        color: var(--mainGreen);
        font-weight: 600;
    }

    .highlighted{
        font-size: 40px!important;
        line-height: 50px;
    }

    .claim{
        padding-top: 80px;
        padding-bottom: 30px;
        font-size: 45px;
        font-weight: 600;
        text-align: center!important;
        line-height: 60px;
        strong{
            font-size: 48px;
            font-weight: 700;
            background-color: var(--mainGreen);
            padding: 0 5px;
        }
    }

    .heading{
        align-items: center;
    }
    .values{
        font-size: 35px;
        font-weight: 800;
    }
    .col {
        margin-bottom: 100px;
        font-size: 16px;
        line-height: 26px;
        // font-weight: 600;

    }
    .logoContainer{
        min-width: 250px;
        img {
            max-height: 80px;
        }
    }

    .screenShot{
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        border-radius: 20px;
    }

</style>